/* ---------------------------------------------- */
  /*   Accordion functionality for submenu items    */
  /* ---------------------------------------------- */
  
  // Handle accordion behavior for theme collection dropdowns
  document.addEventListener("click", (e) => {
    const clickedSummary = e.target.closest("summary")
    if (!clickedSummary) return
    
    // Check if this is a submenu summary (like theme collections)
    const parentDetails = clickedSummary.closest("details")
    const parentSubmenu = clickedSummary.closest(".header__submenu")
    
    if (parentSubmenu && parentDetails) {
      // Find all other details elements in the same submenu
      const allDetailsInSubmenu = parentSubmenu.querySelectorAll("details")
      
      // Close all other details except the one being clicked
      allDetailsInSubmenu.forEach((details) => {
        if (details !== parentDetails && details.hasAttribute("open")) {
          details.removeAttribute("open")
          const summary = details.querySelector("summary")
          if (summary) {
            summary.setAttribute("aria-expanded", "false")
          }
        }
      })
    }
  })
